import {callAPI} from '@/store/utils';

const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {
    investorData: null,
    treasuryPartner: null,
    investorDocuments: null,
    USTBL: {},
    EUTBL: {},
    eurUSTBL: {},
    interestAmounts: {},
  },
  mutations: {
    setInvestor(state, data) {
      state.investorData = data && data[0] ? data[0] : data;
    },
    setPartner(state, data) {
      state.treasuryPartner = data;
    },
    setInvestorDocuments(state, data) {
      state.investorDocuments = data;
    },
    setSpikoInterest(state, evt) {
      state[evt.currency] = evt.data;
    },
    setInterestAmount(state, accs) {
      state.interestAmounts = accs;
    },
  },
  actions: {
    async actionGetCompanyInvestor({commit}) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('GET', `company/${companyId}/investor`);
      commit('setInvestor', res.result);
    },
    async actionGetStaticLegalDocument({state}, partner_id) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'GET',
        `company/${companyId}/investor/partner/${partner_id}/staticLegalDocument`,
      );
      return res.result;
    },
    async actionSendLegalDocument({state}, data) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        `company/${companyId}/investor/${data.investor_id}/sendLegalDocument`,
        {...data},
      );
      return res.result;
    },

    async actionSaveInvestor({commit}, params) {
      const company_id = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        params.requestType,
        `company/${company_id}/investor`,
        {
          ...params,
          company_id,
        },
      );
      return res;
    },
    async actionUploadInvestorDocument({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'uploadInvestorDocument', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetInvestorDocuments({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getInvestorDocuments', {
        ...params,
        companyId,
      });
      commit('setInvestorDocuments', res.result);
      return res;
    },
    async actionValidateInvestor({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'validateInvestor', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetDocumentUrl({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getInvestorDocument', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionDeleteDocument({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('DELETE', 'deleteDocument', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionCreateTransferOrder({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'createTransferOrder', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionCreateTransferOrderAttempt({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'createTransferOrderAttempt', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionGetTreasuryInvestmentInterests({commit}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getTreasuryInvestmentInterests', {
        ...params,
        companyId,
      });
      commit('setInterestAmount', res.result);
      return res;
    },
    async actionGetSpikoInterest({commit, state}, currency) {
      if (
        state[currency] &&
        Object.keys(state[currency]).length > 0 &&
        state[currency].nextYieldTimestamp
      ) {
        if (new Date() < new Date(state[currency].nextYieldTimestamp * 1000)) {
          return;
        }
      }
      const res = await fetch(
        `https://public-api.spiko.io/share-classes/${currency}/yield`,
      );
      const data = await res.json();
      commit('setSpikoInterest', {currency, data});
      return data;
    },
    async actionUpdateTransferOrderStatus({commit, state}, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'transferOrder/updateTransferOrderStatus',
        {
          ...params,
          company_id: companyId,
        },
      );
      return res;
    },
  },
};
